import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DeliveryForFee } from '../interfaces/deliveryforfee.interface';
import { Router } from '@angular/router'; 
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeliveryForFeeService {
  private deliveryforfeesUrl =  environment.apiUrl + '/handlers/deliveryforfeegetall.php';  // URL to web api
  private updatedeliveryforfeeUrl =  environment.apiUrl + '/handlers/deliveryforfeeupdate.php';  // URL to web api
  private getdeliveryforfeeUrl =  environment.apiUrl + '/handlers/deliveryforfeeget.php';  // URL to web api
  private createdeliveryforfeeUrl =  environment.apiUrl + '/handlers/deliveryforfeecreate.php';  // URL to web api
  private deletedeliveryforfeeUrl =  environment.apiUrl + '/handlers/deliveryforfeedelete.php';  // URL to web api

  deliveryforfees: DeliveryForFee[] = [];
  selectedDeliveryForFee: DeliveryForFee = {} as DeliveryForFee;

  constructor(private http: HttpClient, private router: Router) { }
  
    async updateDeliveryForFee(id: number, productcode: string, returndocno:string, returndate:string, warehousecode:string, dffvolume:number, volumeid:string, lineno:number, customercode: string, uploaded:string): Promise<any> 
    {
      let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
      let user = JSON.parse(cuser);
      let distid = user['distid'];
      const data$ = this.http.post(this.updatedeliveryforfeeUrl, JSON.stringify({id: id, productcode:productcode,returndocno:returndocno,returndate:returndate,warehousecode:warehousecode,dffvolume:dffvolume,volumeid:volumeid,lineno:lineno,customercode: customercode,uploaded:uploaded,distid:distid}))
         try {
           let x = await firstValueFrom(data$);
           return x;
         }
         catch (error) {
           console.error(
             'Error in update delivery for fee service!', error);
             return;
         }
    }
    
      async getDeliverForFees(): Promise<DeliveryForFee[]> 
        {
          let cuser = localStorage.getItem('currentUser');
          if (cuser === null) {
                throw new Error('Not logged in');
          }
          let user = JSON.parse(cuser);
          let distid = user['distid'];
          const data$ = this.http.post<DeliveryForFee[]>(this.deliveryforfeesUrl,JSON.stringify({ distid: distid }));
          try {
            this.deliveryforfees = await firstValueFrom(data$);
            return this.deliveryforfees;
          }
          catch (error) {
            console.error('Get all delivery for fees service!', error);
            throw error;
          };  
        }

async deleteDeliveryForFee(id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
try 
    {
      const data$ = await this.http.post(this.deletedeliveryforfeeUrl,JSON.stringify({id: id, distid: distid }))
      let response = await firstValueFrom(data$);
      return;
    }
    catch (error) 
    {
      console.error(
              'Delete Delivery For Fee Service Error: ', error);
              throw error;
    };  
   }  

async create(productcode: string, returndocno:string, returndate:string, warehousecode:string, dffvolume:number, volumeid:string, lineno:number, customercode: string, uploaded:string): Promise<any> {
    let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
    let user = JSON.parse(cuser);
    let distid = user['distid'];

    const data$ = this.http.post(this.createdeliveryforfeeUrl, JSON.stringify({productcode:productcode,returndocno:returndocno,returndate:returndate,warehousecode:warehousecode,dffvolume:dffvolume,volumeid:volumeid,lineno:lineno,customercode: customercode,uploaded:uploaded,distid:distid}))
         try {
           let x = await firstValueFrom(data$);
           return x;
         }
         catch (error) {
           console.error(
             'Error in create delivery for fee service!', error);
             return;
         };  
  }

}
